<template>
  <el-dialog title="產生待機腳本" :visible.sync="innerVisible" width="450px" :close-on-click-modal="false">
    <el-form :model="form" ref="form" :rules="rules" label-width="100px" @submit.native.prevent="submit">
      <el-form-item label="檔案名稱" prop="name">
        <el-input v-model="form.name" placeholder="例如：sleep.slideshow"></el-input>
      </el-form-item>
      <el-form-item label="備註" prop="description">
        <el-input v-model="form.description" placeholder="備註資訊"></el-input>
      </el-form-item>
    </el-form>

    <div class="slideshow-info">
      <p>將在目前目錄下產生腳本檔案。</p>
      <p>此腳本將會指示月光機在待機時，輪播 <b>Photo/weather</b> 資料夾中的天氣預報圖片。</p>
      <el-divider></el-divider>
      <p><b>預期內容：</b></p>
      <div class="preview-box">
        [HINN_SLIDESHOW V1.0]<br/>
        LOCK (0);<br/>
        LOOPMODE (3);<br/>
        REPEAT (255);<br/>
        ... (自動包含天氣圖片列表)
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="submitting">產 生</el-button>
    </div>
  </el-dialog>
</template>

<script>
import API from "@/api/";

export default {
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    parentId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      submitting: false,
      form: {
        name: "sleep.slideshow",
        description: "系統自動產生",
      },
      rules: {
        name: [{ required: true, message: "請輸入檔案名稱", trigger: "blur" }],
      },
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.name = "sleep.slideshow";
        this.form.description = "系統自動產生";
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      }
    },
  },
  methods: {
    async submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.parentId) {
            this.$message.error("目錄 ID 錯誤");
            return;
          }
          this.submitting = true;
          try {
            await API.asset.createSlideshowAsset({
              parentId: this.parentId,
              name: this.form.name,
              description: this.form.description,
              src: "https://api.ml2-mgmt.gebis.net/ml2/sleep-slideshow",
            });
            this.$message.success("待機腳本產生成功");
            this.innerVisible = false;
            this.$emit("success");
          } catch (err) {
            console.error(err);
          } finally {
            this.submitting = false;
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.slideshow-info {
  line-height: 1.6;
}
.preview-box {
  background: #f5f7fa;
  padding: 10px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 12px;
  color: #606266;
  border: 1px solid #e4e7ed;
  margin-top: 10px;
}
</style>
